import { useCallback, useEffect, useState } from 'react';

export const convertRemToPixels = (rem: number) => {
  return rem * parseFloat(getComputedStyle(document.documentElement).fontSize);
};

export const useRelativeUnits = (ref: React.RefObject<HTMLElement>) => {
  const [lineWidth, setLineWidth] = useState(0);
  const [tooltipCircle, setTooltipCircle] = useState(0);
  const [xAxisHeight, setXAxisHeight] = useState(0);
  const [yAxisWidth, setYAxisWidth] = useState(0);

  const resizeCallback = useCallback(() => {
    setLineWidth(convertRemToPixels(0.1));
    setTooltipCircle(convertRemToPixels(0.4));
    setXAxisHeight(convertRemToPixels(0.3));
    setYAxisWidth(convertRemToPixels(1.7));
  }, []);

  useEffect(() => {
    const initResizeObserver = (observer: ResizeObserver) => {
      window.requestAnimationFrame(() => {
        if (ref.current) {
          observer.observe(ref.current);
        }
      });
    };

    const resizeObserver = new ResizeObserver(() => {
      if (ref.current) {
        const initialSize = ref.current?.getBoundingClientRect();
        resizeCallback();
        const newSize = ref.current?.getBoundingClientRect();

        if (
          initialSize.width !== newSize.width ||
          initialSize.height !== newSize.height
        ) {
          resizeObserver.unobserve(ref.current);
          initResizeObserver(resizeObserver);
        }
      }
    });

    initResizeObserver(resizeObserver);
  }, [ref, resizeCallback]);

  return {
    lineWidth,
    tooltipCircle,
    xAxisHeight,
    yAxisWidth,
  };
};
